var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen center-loader",attrs:{"id":"global-loader"}},[_c('div',{staticClass:"spinner"}),_c('span',{staticClass:"spinner-text fullscreen center-loader"},[_vm._v(_vm._s(_vm.$store.state.loader.text_loader))])])}
var staticRenderFns = []

export { render, staticRenderFns }